import React, { Component } from 'react';
import RbUtil from './../../util/RbUtil';
import ComponentHelper from '../../util/ComponentHelper';

export default class CoreComponent extends React.Component{

	rb(rawTxt,replaceStringArray=[]){
		return RbUtil.getText(rawTxt,replaceStringArray);
	}

	getCmpHelper(userStore){
		return ComponentHelper(userStore);
	}

	render(){

		return(
			<div></div>
			);
		}

	}


// WEBPACK FOOTER //
// ./src/components/core/CoreComponent.js